'use strict';

import Vue from 'vue/dist/vue.common.js';
import VueResource from 'vue-resource';

Vue.use(VueResource);

export default {
  get() {
    return Vue.http.post('/api/csrf_token')
      .then(response => Promise.resolve(response.data.data.token))
      .catch(error => Promise.reject(error));
  }
};



// WEBPACK FOOTER //
// ./app/javascript/vue/services/csrf.js